<template>
  <div class="flex flex_gap_10">
    <v-popover
      placement="right"
      trigger="hover"
      :delay="{ show: 100, hide: 500 }"
    >
      <span :class="{
        'badge-success': task.status === 2,
        'badge-warning': task.status !== 2,
        'pointer badge': true,
        }"
            @click="mixinOpenDrawer({type: 'drugTasks003', task: {...task,task_data: {...task.task_data}}})">
      <i class="icon-fa icon-fa-phone"/>
      </span>
      <template slot="popover">
        <div>
          <div v-for="(c,i) in getComments()" class="comment" v-if="i < 2">
            <p>{{ c.text }}</p>
            <p class="text-right text-muted fs-11">{{ printDate(c.created_at) }}</p>
          </div>
          <div v-if="(getComments().length - 1) > 2">
            <p class="text-right">всего комментариев: <strong>{{ getComments().length - 1 }}</strong></p>
          </div>
        </div>
      </template>
    </v-popover>
    <span>{{ printDate(task.updated_at, 'DD.MM.YYYY') }}</span>
  </div>
</template>

<script>

export default {
  props: ['task', 'record'],
  methods: {
    getComments() {
      return [...[{
        text: this.task?.task_data?.comment,
        created_at: this.task.created_at
      }], ..._.orderBy((this.task.task_data?.report?.comments ?? []), 'created_at')].toReversed();
    }
  }
}

</script>

<style scoped>
i {
  font-size: 15px;
  color: white;
}
</style>
